export const DEFAULT_DISTANCES_IN_METERS = 20_000;
export const DEFAULT_DURATIONS_IN_MINUTES = 50;
